<template>
  <div class="ticketCheck">
    <div class="center border">
      <div class="numberInfo">告知单编号≠处罚决定书编号</div>
      <div class="img">
        <img src="@/assets/img/ticket/errTicket.png" alt="">
        <img src="@/assets/img/ticket/sucTicket.png" alt="">
      </div>
      <div class="carTitle">车牌号码</div>
      <car-number :inputValue="inputValue" @submit="carSubmit"></car-number>
    </div>
    <div class="center">
      <div class="fieldTitle">现场处罚决定书编号</div>
      <van-field
        v-model="formData.ticketNo"
        size="large"
        placeholder="请输入15-16位处罚决定书编号"
        maxlength="16"
        type="number"
        class="field"
      />
    </div>
    <div class="center">
      <van-field
          v-model="formData.ticketDate"
          label="处罚日期"
          placeholder="请选择日期"
          type="data"
          is-link
          readonly
          label-class="fieldLabel"
          class="field fieldInput"
          @click="showDatePicker = true"
        />
    </div>
    <div class="center">
      <van-form>
        <van-field
          v-model="formData.ticketAmount"
          label="处罚金额"
          placeholder="请输入金额"
          type="number"
          label-class="fieldLabel"
          class="field fieldInput"
          :rules="rules.ticketAmount"
        />
      </van-form>
    </div>
    <div class="check">
      <!-- <van-checkbox v-model="checked" shape="square" icon-size="0.25rem">已阅读并同意授权</van-checkbox> -->
    </div>
    <div class="btn">
      <van-button type="info" size="large" :disabled="disabled" @click="goTicketPay">查询罚单</van-button>
    </div>
    <div class="thirdParty">由第三方服务商提供</div>
    <div class="text--bottom" @click="goOrder">我的订单</div>
    <!-- 日期选择器弹出层 -->
    <van-popup 
      v-model="showDatePicker" 
      round
      position="bottom">
      <van-datetime-picker
        type="date"
        :value="defaultDate"
        :min-date="dateRange.min"
        :max-date="dateRange.max"
        :formatter="dateFormatter"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import CarNumber from '../../components/car-number.vue';
import { complement0 } from '@/utils/index'
import { getTicketPayment,findProductList } from "@/common/api.js";
import schema from 'async-validator'
export default {
  name: "ticketCheck",
  components: {
    CarNumber
  },
  data() {
    return {
      isShow: true,
      formData: {},
      showDatePicker: false,
      defaultDate: new Date(),
      dateRange:{
        min: new Date('1980/1/1'),
        max: new Date()
      },
      // checked: false,
      inputValue: [],
      carNo: [],
      ticketDate: '',
      services: {},
      rules: {
        ticketAmount: [
          { pattern: /^([1-9]\d{0,4}|0)(\.\d{1,2})?$/, message: '请输入最多值99999.99的正确金额格式' }
          
        ]
      }
    }
  },
  watch: {
    inputValue(val) {
      this.carNo = val
    },
    showDatePicker(val) {
      if(!val){
        this.ticketDate = this.formData.ticketDate
      }
    }
  },
  computed: {
    disabled(){
      return !(this.carNo && this.carNo.length == 7 && this.formData.ticketNo && this.ticketDate && this.formData.ticketAmount) 
    }
  },
  mounted() {
    this.formData.contactPhone = this.$route.query.phone
    this.findProductList()
  },
  methods: {
    async findProductList() {
      const data = {
        categoryCodeList: [this.$route.query.categoryCode],
        pageNum: 1,
        pageSize: 10,
      }
      const res = await findProductList(data)
      console.log(res.list);
      this.services = res.list[0]
    },
    toClick() {
      this.isClick = true
    },
    dateFormatter(type, val) {
      switch (type) {
        case 'year':
          return val + '年';
        case 'month':
          return val + '月';
        case 'day':
          return val + '日';
        default:
          return val
      }
    },
    onDateConfirm(time) {
      const res = time.getFullYear() + '-'
                + complement0(time.getMonth() + 1) + '-'
                + complement0(time.getDate())
      this.formData.ticketDate = res
      this.showDatePicker = false
    },
    carSubmit(val) {
      this.formData.carNo = val
    },
    async getTicketPayment() {
      this.$toast.loading({
        message: "查询中",
        forbidClick: true,
        duration: 0,
      })
      this.formData.productCode = this.services.productCode
      const res = await getTicketPayment(this.formData)
      const data = {...this.formData, ...res}
      this.$toast.clear()
      this.$router.push({
        path: '/ticketPay',
        query: {
          phone: this.$route.query.phone,
          productCode: this.services.productCode,
          categoryCode: this.services.categoryCode,
          formData: JSON.stringify(data)
        },
      });
    },
    async goTicketPay() {
      const validator = new schema(this.rules)
      try {
				await validator.validate(this.formData)
			} catch ({ errors }) {
				this.$toast(errors[0].message)
				return
			}
      this.getTicketPayment()
    },
    goOrder() {
      this.$router.push({
        path: '/orderList',
        query: {
          phone: this.$route.query.phone,
          categoryName: this.services.categoryName,
          categoryCode: this.services.categoryCode,
          productCode: this.services.productCode,
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">
.ticketCheck{
  width: 100%;
  background: #F4F6F7;
  font-family:'Microsoft YaHei';
  .border{
    border-top: 0.3rem solid #F4F6F7;
  }
  .center{
    border-bottom: 1px solid #e6e6e6;
    padding: 0.1rem 0.4rem 0.3rem;
    background: #fff;
    .numberInfo{
      font-size: 0.26rem;
      color: #787878;
      height: 0.8rem;
      line-height: 0.8rem;
    }
    .img{
      display: flex;
      justify-content: space-between;
      img{
        width: 43vw;
      }
    }
    .carTitle{
      font-size: 0.36rem;
      color: #383838;
      font-weight: 500;
      margin: 0.5rem 0 0.3rem;
    }
  }
  .fieldTitle{
    font-size: 0.3rem;
    color: #787878;
    height: 0.9rem;
    line-height: 0.9rem;
  }
  .field{
    padding: 0;
    font-size: 0.3rem;
  }
  .fieldInput{
    padding-top: 0.32rem;
  }
  /deep/ .fieldLabel{
    font-size: 0.3rem;
    color: #787878;
  }
  .check{
    font-size: 0.26rem;
    color: #787878;
    padding: 0.8rem 0 0.3rem;
    display: flex;
    justify-content: center;
    background: #fff;
  }
  .btn{
    display: flex;
    justify-content: center;
    padding: 0 0.4rem 0;
    background: #fff;
    /deep/ .van-button{
      border-radius: 0.16rem;
    }
  }
  .thirdParty{
    font-size: 0.24rem;
    color: #C8C8C8;
    text-align: center;
    background: #fff;
    line-height: 0.8rem;
  }
  .text--bottom {
    padding-top: 0.5rem;
    background: #fff;
    font-size: 0.32rem;
    width: 100vw;
    text-align: center;
    color: #5986B3;
  }
}

</style>